import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "finishedToCompleted" })
export class CompletedPipe implements PipeTransform {
  transform(value: string) {
    return value.replace("FINISHED", "COMPLETED");
  }
}
